interface SectionHeadingProps {
  kicker?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {kicker ? (
        <span
          className={`mb-3 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] ${
            light ? "text-accent-300" : "text-primary-600"
          }`}
        >
          <span className={`h-px w-6 ${light ? "bg-accent-300" : "bg-primary-400"}`}></span>
          {kicker}
        </span>
      ) : null}
      <h2
        className={`font-heading text-2xl font-bold md:text-3xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            light ? "text-background-200/90" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}